module.exports = __webpack_public_path__ + "80116ba2917ce11cb2a37aef68aafae0.pdf";